// extracted by mini-css-extract-plugin
export default {"main":"App_main__Cqcc-","form":"App_form__xYj+3","bg":"App_bg__tUnxZ","langPickerWrapper":"App_langPickerWrapper__iqRSa"};